// extracted by mini-css-extract-plugin
module.exports = {"systemMessage":"_2BsC6fCS1MzzG6Ytc4mJtB","inSelectionMode":"o6WHBszWWYSXubr96d6HI","messageContainer":"_2Oen979DY3RMKtZ7syvaGn","messageContent":"_2B3gUGFu861FcGjfFyzibh"};